import type { Table } from 'dexie';

import Dexie from 'dexie';

import type { Log, LogId, MediaFile, MediaFileId } from './schema';

export class Database extends Dexie {
    mediaFiles: Table<MediaFile, MediaFileId>;
    logs: Table<Log, LogId>;

    constructor() {
        super('connected-db');

        /**
         * # Schema Syntax
         * - **`++`** is an auto-incremented primary key
         * - **`&`** is a unique index
         * - **`*`** is a multi-entry index
         * - **`[id1+id2]`** is a compound primary key
         *
         * > NOTE: Don’t declare all columns like in SQL. You only declare properties you want to index, that is properties you want to use in a where(…) query.
         */
        this.version(1).stores({
            mediaFiles: `mediaFileId, name, size, mimeType, opfsPath`,
            logs: `logId, projectVersionId, message, level`,
        });

        this.mediaFiles = this.table('mediaFiles');
        this.logs = this.table('logs');
    }
}

export const db = new Database();
